import { Stack, Typography } from "@mui/material";
import { capitalize } from "lodash-es";
import type { FC } from "react";
import type { MomentRecipientsClassify } from "../../../../../../hooks/use-moment-recipients-classify";
import { PreviewWithSidebarAutocomplete } from "./preview-with-sidebar-autocomplete";

export const PreviewWithSidebarConnection: FC<{
  data: Extract<MomentRecipientsClassify, { type: "connection" }>["data"];
}> = ({ data }) => {
  return (
    <Stack direction="column" spacing={2}>
      <Typography variant="body2">Select a subject to preview merge tags</Typography>
      <Typography variant="body2" color="textSecondary">
        Message to {capitalize(data.connection_type)} of subjects in {data.segment_name}
      </Typography>
      <PreviewWithSidebarAutocomplete info={{ type: "connection", data }} />
    </Stack>
  );
};
